/**
 * 零售兑奖相关接口列表
 */
import axios from '@/request/http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块

const bonus = {
    //获取商家发布的零售兑奖商品
    getShopBonusGoodsList(params) {
        return axios.post('/goods/shopBonus/getShopBonusGoodsList', qs.stringify(params));
    },
    //获取用户兑奖车信息列表
    getUserShopBonusCarList(params) {
        return axios.post('/goods/shopBonus/getUserShopBonusCarList', qs.stringify(params));
    },
    //加入兑奖车信息
    addShopBonusCarInfo(params) {
        return axios.post('/goods/shopBonus/addShopBonusCarInfo', qs.stringify(params));
    },
    //修改兑奖车数量
    changeShopBonusCarNum(params) {
        return axios.post('/goods/shopBonus/changeShopBonusCarNum', qs.stringify(params));
    },
    //删除兑奖车信息
    delShopBonusCarInfo(params) {
        return axios.post('/goods/shopBonus/delShopBonusCarInfo', qs.stringify(params));
    },
    //创建兑奖申请单
    createShopBonusOrder(params) {
        return axios.post('/goods/shopBonus/createShopBonusOrder', qs.stringify(params));
    },
    //用户获取申请单信息
    getShopBonusOrderList(params) {
        return axios.post('/goods/shopBonus/getShopBonusOrderList', qs.stringify(params));
    },
    //用户申请单详情
    getShopBonusOrderDetail(params) {
        return axios.post('/goods/shopBonus/getShopBonusOrderDetail', qs.stringify(params));
    },
    //获取兑奖规则信息
    getFpRetailBonusRuleInfo(params) {
        return axios.post('/goods/retailBonus/getFpRetailBonusRuleInfo', qs.stringify(params));
    }





}

export default bonus;


// WEBPACK FOOTER //
// ./src/request/api/integral/bonus.js